import { render, staticRenderFns } from "./TagManagerSummary.template.vue?vue&type=template&id=12e1cf70&scoped=true&"
var script = {}
import style0 from "./TagManagerSummary.template.vue?vue&type=style&index=0&id=12e1cf70&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e1cf70",
  null
  
)

export default component.exports